<div class="modal">
  <div class="modal-ctn picker">

    <div class="options">
      <span class="picker-title">{{ 'UI.PICK.FLOWMETER' | translate }}</span>
      <df-input type="search" prefixIcon="heroMagnifyingGlass" allowClear (valueChange)="filter($event)" />
      <button type="button" class="icon-action" title="Close" (click)="close()"><ng-icon name="heroXMark" size="20"/></button>
    </div>

    <div class="flowmeters picker-list">
      @for (flowmeter of displayedFlowmeters; track flowmeter) {
        <div class="flowmeter picker-item">
          <div class="logo">
            <ng-icon name="heroArrowsRightLeft" size="18"/>
            <a>{{ flowmeter.flowmeterId }}</a>
          </div>
          <div class="info">
            <a>{{ 'FLOWMETER.NAME' | translate }}: {{ flowmeter.flowmeterName }}</a>
            <a>{{ 'FLOWMETER.MODEL' | translate }}: {{ flowmeter.flowmetermodelName }}</a>
            <a>{{ 'FLOWMETER.FIELD_PROTOCOL' | translate }}: {{ flowmeter.fieldprotocolName }}</a>
          </div>
          <df-button size="sm" variant="primary" class="add" (onClick)="addFlowmeter(flowmeter)">{{ 'UI.SELECT' | translate }}</df-button>
        </div>
      }
    </div>

  </div>
</div>